import InCallManager from "react-native-incall-manager";
import React from "react";

import {
  Alert,
  AppState,
  Image,
  Text,
  TouchableOpacity,
  View
} from "react-native";
import { Voximplant } from "react-native-voximplant";
import { connect } from "react-redux";

import PulseLoader from "../components/PulseLoader";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

import {
  getBaseUrl,
  getVoximplantAccountName,
  getVoximplantAppName
} from "../helpers/storage";

class VideoCallScreen extends React.Component {
  constructor(props) {
    super(props);

    const { doctor, patient, transaction } = this.props.navigation.state.params;

    this.state = {
      audioSent: true,
      cameraType: Voximplant.Hardware.CameraType.FRONT,
      doctor: {
        fullName: doctor.fullName
      },
      isLoading: true,
      localVideoStreamId: null,
      patient: {
        id: patient.id
      },
      remoteVideoStreamId: null,
      transaction: {
        id: transaction.id
      }
    };
  }

  componentDidMount() {
    AppState.addEventListener("change", this.handleAppStateChange);

    InCallManager.start({ media: "video", ringback: "_BUNDLE_" });

    this.client = Voximplant.getInstance();

    this.connect().then(() => this.login());
  }

  componentWillUnmount() {
    AppState.removeEventListener("change", this.handleAppStateChange);

    this.client.disconnect();

    InCallManager.stop({ busytone: "_BUNDLE_" });
  }

  handleAppStateChange = appState => {
    if (appState === "background") {
      if (this.client) {
        this.client.disconnect();
      }
    }
  };

  async connect() {
    await this.client.connect();
  }

  async exchangeLoginKey(key) {
    const { token } = this.props;

    const baseUrl = getBaseUrl();

    const response = await fetch(baseUrl + "call/start", {
      body: JSON.stringify({
        login_key: key
      }),
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json"
      },
      method: "POST"
    });

    const json = await response.json();

    return {
      doctor: {
        alias: json["data"]["doctor"]["alias"]
      },
      token: json["data"]["token"]
    };
  }

  async login() {
    const { patient, transaction } = this.state;

    const accountName = getVoximplantAccountName();
    const appName = getVoximplantAppName();

    const domain = appName + "." + accountName + ".voximplant.com";

    const alias = "patient-" + patient.id;

    try {
      await this.client.requestOneTimeLoginKey(alias + "@" + domain);
    } catch (e) {
      if (e.code === 302) {
        const { doctor, token } = await this.exchangeLoginKey(e.key);

        await this.client.loginWithOneTimeKey(alias + "@" + domain, token);

        this.call = await this.client.call(doctor.alias + "@" + domain, {
          customData: JSON.stringify({
            transaction_id: transaction.id
          }),
          video: {
            receiveVideo: true,
            sendVideo: true
          }
        });
        this.call.on(Voximplant.CallEvents.Disconnected, () =>
          this.props.navigation.goBack()
        );
        this.call.on(Voximplant.CallEvents.EndpointAdded, event => {
          event.endpoint.on(
            Voximplant.EndpointEvents.RemoteVideoStreamAdded,
            event => {
              InCallManager.stopRingback();

              Voximplant.Hardware.AudioDeviceManager.getInstance().selectAudioDevice(
                Voximplant.Hardware.AudioDevice.SPEAKER
              );

              this.setState({
                isLoading: false,
                remoteVideoStreamId: event.videoStream.id
              });
            }
          );
        });
        this.call.on(Voximplant.CallEvents.Failed, e => {
          if (e.code === 603) {
            Alert.alert(
              "Whoops",
              "Mohon maaf untuk sementara dokter tidak dapat menerima panggilan karena trafik yang tinggi."
            );
          }

          this.props.navigation.goBack();
        });
        this.call.on(Voximplant.CallEvents.LocalVideoStreamAdded, event =>
          this.setState({
            localVideoStreamId: event.videoStream.id
          })
        );
      }
    }
  }

  renderContent = () => {
    const {
      audioSent,
      cameraType,
      localVideoStreamId,
      remoteVideoStreamId
    } = this.state;

    return (
      <>
        <Voximplant.VideoView
          scaleType={Voximplant.RenderScaleType.SCALE_FILL}
          style={{ flex: 1 }}
          videoStreamId={remoteVideoStreamId}
        />
        <View
          style={{
            padding: 20,
            position: "absolute",
            right: 0
          }}
        >
          <Voximplant.VideoView
            style={{ height: 150, width: 150 }}
            videoStreamId={localVideoStreamId}
          />
        </View>
        <View
          style={{
            bottom: 0,
            left: 0,
            padding: 40,
            position: "absolute",
            right: 0
          }}
        >
          <View
            style={{
              alignItems: "center",
              flexDirection: "row",
              justifyContent: "center"
            }}
          >
            <TouchableOpacity
              onPress={() => {
                if (cameraType === Voximplant.Hardware.CameraType.FRONT) {
                  Voximplant.Hardware.CameraManager.getInstance().switchCamera(
                    Voximplant.Hardware.CameraType.BACK
                  );

                  this.setState({
                    cameraType: Voximplant.Hardware.CameraType.BACK
                  });
                } else {
                  Voximplant.Hardware.CameraManager.getInstance().switchCamera(
                    Voximplant.Hardware.CameraType.FRONT
                  );

                  this.setState({
                    cameraType: Voximplant.Hardware.CameraType.FRONT
                  });
                }
              }}
            >
              <View
                style={{
                  alignItems: "center",
                  backgroundColor: staticColors.white,
                  borderRadius: 25,
                  height: 50,
                  justifyContent: "center",
                  width: 50
                }}
              >
                <Image
                  source={
                    cameraType === Voximplant.Hardware.CameraType.FRONT
                      ? require("../assets/icons/round_camera_rear_black_36dp.png")
                      : require("../assets/icons/round_camera_front_black_36dp.png")
                  }
                  style={{ height: 30, width: 30 }}
                />
              </View>
            </TouchableOpacity>
            <TouchableOpacity onPress={() => this.props.navigation.goBack()}>
              <View
                style={{
                  alignItems: "center",
                  backgroundColor: staticColors.thimbleberry,
                  borderRadius: 37.5,
                  height: 75,
                  justifyContent: "center",
                  margin: 25,
                  width: 75
                }}
              >
                <Image
                  source={require("../assets/icons/round_call_end_white_36dp.png")}
                  style={{ height: 45, width: 45 }}
                />
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                if (audioSent) {
                  this.call.sendAudio(false);

                  this.setState({
                    audioSent: false
                  });
                } else {
                  this.call.sendAudio(true);

                  this.setState({
                    audioSent: true
                  });
                }
              }}
            >
              <View
                style={{
                  alignItems: "center",
                  backgroundColor: staticColors.white,
                  borderRadius: 25,
                  height: 50,
                  justifyContent: "center",
                  width: 50
                }}
              >
                <Image
                  source={
                    audioSent
                      ? require("../assets/mic-on.png")
                      : require("../assets/mic-off.png")
                  }
                  style={{ height: 30, width: 30 }}
                />
              </View>
            </TouchableOpacity>
          </View>
        </View>
      </>
    );
  };

  renderLoading = () => {
    const { doctor } = this.state;

    return (
      <>
        <View style={{ flex: 1, justifyContent: "space-around" }}>
          <View
            style={{ alignItems: "center", alignSelf: "center", padding: 20 }}
          >
            <Text
              style={{
                color: staticColors.white,
                fontSize: 24,

                ...fonts.regular
              }}
            >
              Panggilan Video
            </Text>
            <Text
              style={{ color: staticColors.white, fontSize: 24, ...fonts.bold }}
            >
              {doctor.fullName}
            </Text>
          </View>
          <PulseLoader />
        </View>
        <View
          style={{
            backgroundColor: staticColors.white,
            borderTopEndRadius: 40,
            borderTopStartRadius: 40,
            marginTop: -40,
            padding: 25
          }}
        >
          <TouchableOpacity
            onPress={() => this.props.navigation.goBack()}
            style={{ alignItems: "center" }}
          >
            <View
              style={{
                alignItems: "center",
                backgroundColor: staticColors.thimbleberry,
                borderRadius: 25,
                height: 50,
                justifyContent: "center",
                width: 50
              }}
            >
              <Image
                source={require("../assets/icons/round_call_end_white_36dp.png")}
                style={{ height: 30, width: 30 }}
              />
            </View>
            <Text
              style={{
                color: staticColors.cavernous,
                fontSize: 18,
                marginTop: 10,

                ...fonts.regular
              }}
            >
              Akhiri Panggilan
            </Text>
          </TouchableOpacity>
        </View>
      </>
    );
  };

  render() {
    const { themeColors } = this.props;
    const { isLoading } = this.state;

    let container;

    if (isLoading) {
      container = this.renderLoading();
    } else {
      container = this.renderContent();
    }

    return (
      <View style={{ backgroundColor: themeColors.primary, flex: 1 }}>
        {container}
      </View>
    );
  }
}

export default connect(state => ({
  themeColors: state.themeColors,
  token: state.token
}))(VideoCallScreen);
